import { CommonModule } from '@angular/common';
import { AuthService } from '../services/auth.service';
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef  } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { EMAIL_REGEX } from 'globals/helpers/constants';

@Component({
    selector: 'forgot-password-dialog',
    template: `
<div class="joi-dialog forgot-dialog">
    <div mat-dialog-title>Forgot your password?</div>
    <ng-container *ngIf="!email_sent; else sent">
      <form #forgotForm="ngForm">
        <div mat-dialog-content>
            <div class="para">Enter your email address to reset your password.</div>
            <mat-form-field class="general">
                <input matInput type="email" name="email"
                  [pattern]="EMAIL_REGEX" name="email" [(ngModel)]="email" placeholder="Email" minlength="6" required>
            </mat-form-field>
        </div>
        <div mat-dialog-actions>
            <button mat-button (click)="dialogRef.close()">CANCEL</button>
            <button mat-button color="primary" [disabled]="forgotForm.invalid" (click)="handle_reset()">Reset password</button>
        </div>
      </form>
    </ng-container>
</div>
<ng-template #sent>
    <div mat-dialog-content>
        <div class="note">If a Joi ID exists for <b>{{email}}</b>, we’ve sent an email with instructions on how to reset your password.</div>
        <div class="caption"><i>Note: You may need to check your spam folder.</i></div>
    </div>
    <div mat-dialog-actions>
        <button mat-button color="primary" (click)="dialogRef.close()">Close</button>
    </div>
</ng-template>
`,
    styles: [`
    .forgot-dialog .para { font-size:14px; line-height: 22px; margin-bottom: 40px; }
    .forgot-dialog .note { font-size:14px; line-height: 22px; margin-bottom: 20px; color:#41474F; }
    .forgot-dialog .caption { font-size:12px; line-height: 16px; margin-bottom: 20px; }
    `],
    standalone: true,
    imports: [FormsModule, MatFormFieldModule, CommonModule, MatInputModule]
})
export class ForgotPasswordDialogComponent {
    email;
    EMAIL_REGEX = EMAIL_REGEX
    email_sent = false;
    constructor(public dialogRef: MatDialogRef<ForgotPasswordDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private auth: AuthService) {
    }
    handle_reset() {
        this.email_sent = true;
        this.auth.sendPasswordResetEmail(this.email);
    }
}